import type { SVGProps } from "react";

export default function LineChart(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1="28" y1="27.5" x2="3" y2="27.5" stroke="currentColor" />
      <path
        d="M8 18.8739C9.56522 16.4903 13.3217 14.1319 15.8261 16.2394C18.9565 18.8739 20.5404 24.5059 21.7143 20.7424C23.4029 15.3287 23.1304 14.7341 26 16.2394M8.3913 13.2287C10.7681 12.6911 15.3939 12.0951 16.6087 11.7233C18.1002 11.2667 19.4783 8.83795 20.1304 7.9598C20.3913 7.45801 21.6174 6.60495 22.8696 7.20711"
        stroke="currentColor"
      />
      <line x1="3.5" y1="3" x2="3.5" y2="28" stroke="currentColor" />
    </svg>
  );
}
